module.exports = __webpack_public_path__ + "static/media/synth-warning.fbab4911.mp3";